import React, { useEffect } from "react";
import { Breadcrumb, BreadcrumbItem, Col, Container, Row } from "reactstrap";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { Auth } from "aws-amplify";
import { compose } from "redux";
import _ from "lodash";

import myteamBg from "assets/images/teambg.png";
import { ReactComponent as DummyAvatarSvg } from "assets/images/opt/dummy-avatar.svg";
import getTeamApiCall from "components/shared/utils/getTeamApiCall";
import * as gameAction from "redux/game/action";
import * as loaderAction from "redux/loader/action";
import SubTeams from "./components/SubTeams";
import SideBarTabs from "../landingLibrary/sideBarTabs";

const MyTeamLanding = (props) => {
  const currentUser = _.get(props.gameReducer, "currentUser");

  useEffect(() => {
    var cognitoUser = Auth.userPool.getCurrentUser();
    if (cognitoUser !== null && currentUser?.team !== undefined) {
      Auth.currentAuthenticatedUser({
        bypassCache: true
      })
        .then(async (user) => {
          if (user) {
            const teammm = await getTeamApiCall(currentUser?.team?.id);
            props.setCurrentUser({
              ...currentUser,
              team: teammm
            });
          }
        })
        .catch((err) => {
          console.log(err, "cognito user my team err");
        });
    } else {
      props.history.push("/no-team");
    }
  }, []);

  return (
    <main className="my-team-new-main">
      <Row>
        <Col md={1} className="p-0">
          <SideBarTabs
            current_user={currentUser}
            handleOptClick={() => props.history.push("/outside_team_building")}
          />
        </Col>
        <Col md={11}>
          <div className="my-team-new-breadcrumb">
            <Container>
              <div className="my-team-new-breadcrumb-container">
                <Breadcrumb>
                  <BreadcrumbItem>
                    <a href="/" className="link">
                      Game Library
                    </a>
                  </BreadcrumbItem>
                  <BreadcrumbItem className="link" active>
                    My Team
                  </BreadcrumbItem>
                </Breadcrumb>
                <h2 className="title">My Team</h2>
                <p className="info">
                  Track team engagement, view suggestions, and improve your team
                  culture.{" "}
                </p>
                <div className="team-bg">
                  <img src={myteamBg} alt="teamBg" />
                </div>
              </div>
            </Container>
          </div>

          <SubTeams
            currentUser={currentUser}
            setIsLoading={props.setIsLoading}
            DummyAvatarSvg={DummyAvatarSvg}
          />
        </Col>
      </Row>
    </main>
  );
};

const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer
});

const mapDispatchToProps = (dispatch) => ({
  setIsLoading: (data) => dispatch(loaderAction.setIsLoading(data)),
  setCurrentUser: (data) => dispatch(gameAction.setCurrentUser(data))
});

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(MyTeamLanding);
